import React from 'react';
import { Divider, Skeleton, Typography } from 'antd';
import AntIcon from '@ant-design/icons';
import classnames from 'classnames';
import Paper from '../Paper/Paper';
import styles from './DashboardNumberTileWidget.module.less';

type DataItem = {
  title: string;
  value: number | string;
};

interface DashboardNumberTileWidgetProps {
  isLoading: boolean;
  Icon: React.ComponentType;
  mainItem: DataItem;
  mainSubtitle?: string;
  sideItems?: DataItem[];
  isError: boolean;
}

const renderSideItems = (sideItems: DataItem[], isError: boolean) => {
  const items = sideItems.map((item: DataItem, i: number) => {
    return (
      <div
        key={item.title}
        className={classnames([styles.numbersContainer, i + 1 !== sideItems.length && styles.withRightMargin])}
      >
        <div>
          <Typography.Text className={styles.numbersContentText}>{isError ? 'n/a' : item.value}</Typography.Text>
        </div>
        <div>
          <Typography.Text type="secondary" className={styles.numbersTitleText}>
            {item.title}
          </Typography.Text>
        </div>
      </div>
    );
  });

  return <>{items}</>;
};

const DashboardNumberTileWidget = ({
  isLoading,
  mainItem: { title: mainTitle, value: mainValue },
  Icon: CustomIcon,
  sideItems,
  mainSubtitle,
  isError
}: DashboardNumberTileWidgetProps) => {
  const sideItemPlates = sideItems && sideItems.length && renderSideItems(sideItems, isError);
  return (
    <Paper data-testid="dashboardNumberTileWidget">
      {!isLoading ? (
        <div className={styles.widgetContainer}>
          <div className={styles.mainBox}>
            <div className={styles.numbersContainer}>
              <AntIcon className={styles.tileIcon} component={() => <CustomIcon />} />
            </div>
            <div className={classnames([styles.numbersContainer, styles.totalCaptionBox])}>
              <div>
                <Typography.Text className={styles.numbersContentText}>{isError ? 'n/a' : mainValue}</Typography.Text>
                {!isError && <Typography.Text> {mainSubtitle}</Typography.Text>}
              </div>
              <div>
                <Typography.Text type="secondary" className={styles.numbersTitleText}>
                  {mainTitle}
                </Typography.Text>
              </div>
            </div>
            {Array.isArray(sideItems) && sideItems.length && (
              <div className={classnames([styles.numbersContainer, styles.withRightMargin, styles.withLeftMargin])}>
                <Divider className={styles.divider} type="vertical" />
              </div>
            )}
          </div>
          {sideItemPlates}
          <div />
        </div>
      ) : (
        <Skeleton active paragraph={{ rows: 2 }} />
      )}
    </Paper>
  );
};

export default DashboardNumberTileWidget;
